import { render, staticRenderFns } from "./CatalogProductSettingAttributeBundleSelection.vue?vue&type=template&id=102d54c6&scoped=true&"
import script from "./CatalogProductSettingAttributeBundleSelection.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingAttributeBundleSelection.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingAttributeBundleSelection.vue?vue&type=style&index=0&id=102d54c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102d54c6",
  null
  
)

export default component.exports